import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../api";
import { useAlert } from "react-alert";
import userAction from "../../redux/users/action";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { BeforePayTerms } from "../modals/beforePayTermsModal";
import { TextPopupModal } from "../modals/textPopup";
import trendMeter from "../../images/trendMeter.png";
import arc from "../../images/Arc1.png";
import { LiquidationData } from "../web3MarketData/liquidationData";
import { Volume24H } from "../web3MarketData/volume24H";
import { LiquidityLens } from "../web3MarketData/liquidityLens";
import { LiveTrades } from "../web3MarketData/liveTrades";
import { WhaleTrades } from "../web3MarketData/whaleTrade";
import { GiSpermWhale } from "react-icons/gi";
import { VolatilityIndex } from "../web3MarketData/volatilityIndex";
import { FaChartArea } from "react-icons/fa";

export const Indicators = ({ SubsData }) => {
  const alert = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { setUser } = userAction;
  const userStore = useSelector((state) => state.userReducer);
  const [loader, setLoader] = useState(true);
  const [isSubscription, setIsSubscription] = useState(false);
  const [trendData, setTrendData] = useState({});
  const [activeNav, setActiveNav] = useState("trend");

  const getMarketTrend = async () => {
    try {
      const resp = await api.getMarketTrend();
      // console.log(resp);
      if (resp?.marketTrend?.trend_score) {
        setTrendData({
          trend_score: resp?.marketTrend?.trend_score,
          buy_pressure: resp?.marketTrend?.buy_pressure,
          sell_pressure: resp?.marketTrend?.sell_pressure,
        });
      }
    } catch (e) {
      console.log(e.message);
      setLoader(false);
    }
  };

  useEffect(() => {
    // console.log(userStore?.users?.user?.email);

    if (userStore?.users?.user?.email) {
      getMarketTrend();
    }
  }, [userStore, SubsData]);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="contact-widget-area indicatorPage">
              <div className="contact-widget-area-inner ">
                <div className="indicatorMain">
                  <div className="iNav">
                    <div
                      className={activeNav == "trend" ? "link active" : "link"}
                      onClick={() => setActiveNav("trend")}
                    >
                      <i className="fa-solid fa-money-bill-trend-up"></i>
                      <span>Trend</span>
                    </div>
                    <div
                      className={
                        activeNav == "liquidation" ? "link active" : "link"
                      }
                      onClick={() => setActiveNav("liquidation")}
                    >
                      <i className="fa-solid fa-chart-column"></i>
                      <span>Liquidation</span>
                    </div>
                    <div
                      className={
                        activeNav == "liduidityLens" ? "link active" : "link"
                      }
                      onClick={() => setActiveNav("liduidityLens")}
                    >
                      <i
                        className="fa-solid fa-square-poll-horizontal"
                        style={{ fontSize: 20 }}
                      ></i>
                      <span>Liduidity Lens</span>
                    </div>
                    <div
                      className={activeNav == "volume" ? "link active" : "link"}
                      onClick={() => setActiveNav("volume")}
                    >
                      <i className="fa-solid fa-chart-simple"></i>
                      <span>24H Volume</span>
                    </div>
                    <div
                      className={
                        activeNav == "livetrades" ? "link active" : "link"
                      }
                      onClick={() => setActiveNav("livetrades")}
                    >
                      <i className="fa-solid fa-chart-line"></i>
                      <span>Live Trades</span>
                    </div>
                    <div
                      className={
                        activeNav == "whaletrades" ? "link active" : "link"
                      }
                      onClick={() => setActiveNav("whaletrades")}
                    >
                      <div style={{ fontSize: 24 }}>
                        <GiSpermWhale />
                      </div>
                      <span>Whale Trades</span>
                    </div>
                    <div
                      className={
                        activeNav == "volatility" ? "link active" : "link"
                      }
                      onClick={() => setActiveNav("volatility")}
                    >
                      <div style={{ fontSize: 24 }}>
                        <FaChartArea />
                      </div>
                      <span>Volatility Index</span>
                    </div>
                  </div>
                  {activeNav == "trend" && (
                    <div className="marketTrendM">
                      <h3>Market Pressure</h3>
                      <div className="presureRow">
                        <div
                          className="buy"
                          style={{ width: `${trendData?.buy_pressure}%` }}
                        >
                          Buying Pressure: {trendData?.buy_pressure || 0}%
                        </div>
                        <div
                          className="sell"
                          style={{ width: `${trendData?.sell_pressure}%` }}
                        >
                          Selling Pressure: {trendData?.sell_pressure || 0}%
                        </div>
                      </div>
                      <h3>Current Market Trend</h3>
                      <div className="tradeCard">
                        <div className="meter">
                          <img src={trendMeter} alt="" />
                        </div>
                        <div
                          className="arc"
                          style={{
                            transform: `translate(-50%, -100%) rotate(${
                              -90 +
                              (trendData?.trend_score
                                ? trendData?.trend_score * 1.8
                                : 0)
                            }deg)`,
                          }}
                        >
                          <img src={arc} alt="" />
                        </div>
                        <div className="number">
                          {trendData?.trend_score || 0}
                        </div>
                      </div>
                    </div>
                  )}
                  {activeNav == "liquidation" && <LiquidationData />}
                  {activeNav == "volume" && <Volume24H />}
                  {activeNav == "liduidityLens" && <LiquidityLens />}
                  {activeNav == "livetrades" && <LiveTrades />}
                  {activeNav == "whaletrades" && <WhaleTrades />}
                  {activeNav == "volatility" && <VolatilityIndex />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
